import PropTypes from 'prop-types';
import React from 'react';
import {observer} from 'mobx-react';

import {DirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HealthFundDisclaimer extends React.Component {
    static contextType = DirectoryStoreContext;

    static propTypes = {
        main: PropTypes.bool,
    };

    static defaultProps = {
        main: false,
    };

    getDisclaimerText(name) {
        return (
            <>
                {'Consultations with these practitioners may be eligible for '}
                <strong>{name}</strong>
                {' rebate when members have applicable Extras cover'}
            </>
        );
    }

    // Return showAllSpecialtiesSearchResults text if target specialty is
    // contained within showAllSpecialties list.
    // Otherwise if specialty is of type medical return the searchResultsText
    // Otherwise return the default disclaimer text.
    getSearchResultsText() {
        const {
            rootStore: {
                healthFundStore: {healthFund},
            },
            specialty,
        } = this.context;
        const {
            name,
            searchResultsText,
            showAllSpecialties,
            showAllSpecialtiesSearchResultsText,
        } = healthFund;
        let searchResultsDisplayText = searchResultsText;
        if (showAllSpecialties && showAllSpecialties.includes(specialty.id)) {
            searchResultsDisplayText = showAllSpecialtiesSearchResultsText;
        } else {
            if (!specialty.isMedical || !searchResultsDisplayText) {
                searchResultsDisplayText = this.getDisclaimerText(name);
            }
        }
        return searchResultsDisplayText;
    }

    render() {
        const {
            bannerAdsHaveLoaded,
            bannerAds,
            locationSearchAPI,
            searchResultsError,
            rootStore: {
                healthFundStore: {healthFund},
                paramStore: {hasSkin},
            },
        } = this.context;
        if (
            !healthFund?.name ||
            searchResultsError ||
            (!bannerAds.length && !locationSearchAPI.results?.length) ||
            !bannerAdsHaveLoaded
        ) {
            return null;
        }
        const {avatar, name, searchResultsDisclaimerText} = healthFund;
        const sRT = this.getSearchResultsText();
        return (
            <>
                {this.props.main ? (
                    <div className="disclaimer">
                        {!hasSkin && <img src={avatar} />}
                        {typeof sRT === 'string' && (
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: sRT,
                                }}
                            ></p>
                        )}
                        {typeof sRT !== 'string' && <p>{sRT}</p>}
                    </div>
                ) : (
                    <div
                        className="disclaimer"
                        dangerouslySetInnerHTML={{
                            __html: searchResultsDisclaimerText,
                        }}
                    ></div>
                )}
            </>
        );
    }
}
